import { loadRuntimePublicConfig } from './config/runtimePublicConfig';

void loadRuntimePublicConfig().then(() => import('./bootstrap'));
